<template>
  <div class="text-xs-center">
    <v-dialog :value="value" @input="$emit('input')" :width="computedWidth">
      <v-card>
        <v-card-title class="headline grey lighten-2 py-0 title-mobile" primary-title>
          {{ computedTitle }}
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <v-btn flat fab small icon @click="$emit('input')" slot="activator">
              <v-icon>close</v-icon>
            </v-btn>
            <span>Cancelar</span>
          </v-tooltip>
          <v-tooltip bottom>
            <v-btn
              color="primary"
              fab
              dark
              small
              @click="adiciona"
              :loading="loading"
              slot="activator"
            >
              <v-icon>done</v-icon>
            </v-btn>
            <span>Salvar</span>
          </v-tooltip>
        </v-card-title>

        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-autocomplete
                  v-model="modeloAtividade.ModeloAtividade"
                  :items="modelosAtividade"
                  item-text="Descricao"
                  return-object
                  menu-props="auto"
                  label="Modelo Atividade"
                  hide-details
                  prepend-icon="label_important"
                  class="mb-3"
                  auto-select-first
                  no-data-text="Registro não encontrado"
                  @change="changeModeloAtividade"
                ></v-autocomplete>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import Atividade from '@/domain/atividade/Atividade';

export default {
  name: 'ModalModeloAtividade',
  props: {
    value: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      dialog: false,
      loading: false,
      modeloAtividade: {
        IdModeloAtividade: null,
        ModeloAtividade: ''
      }
    }
  },
  computed: {
    ...mapGetters(['modelosAtividade']),
    computedTitle() {
      return 'Selecione o Modelo Atividade';
    },
    computedWidth() {
      return this.$vuetify.breakpoint.smAndDown ? '100%' : '60%';
    },
  },
  watch: {
    value(newValue, oldValue) {
      if (newValue && !this.modelosAtividade.length) this.fetchModelosAtividade();
    }
  },
  methods: {
    ...mapActions(['fetchModelosAtividade']),
    ...mapMutations(['showNotification', 'closeNotification']),
    changeModeloAtividade(obj) {
      this.modeloAtividade.ModeloAtividade = obj.Descricao;
      this.modeloAtividade.IdModeloAtividade = obj.IdModeloAtividade;
    },
    salvaModeloAtividade() {
      const modeloAtividade = {
        IdModeloAtividade: this.modeloAtividade.IdModeloAtividade,
        ModeloAtividade: this.modeloAtividade.ModeloAtividade
      };
      localStorage.setItem('modeloAtividadeModal', JSON.stringify(modeloAtividade));
    },
    recuperaModeloAtividade() {
      if (localStorage.getItem('modeloAtividadeModal')) {
        const modeloAtividade = JSON.parse(localStorage.getItem('modeloAtividadeModal'));
        this.modeloAtividade.IdModeloAtividade = modeloAtividade.IdModeloAtividade;
        this.modeloAtividade.ModeloAtividade = modeloAtividade.ModeloAtividade;
      }
    },
    async adiciona() {
      this.$emit('iniciaAtividadeModeloAtividade', this.modeloAtividade.IdModeloAtividade);
      this.salvaModeloAtividade();
    }
  },
  created() {
    this.recuperaModeloAtividade();
  }
}
</script>

<style scoped>
@media screen and (max-width: 480px) {
  .title-mobile {
    font-size: 1.125rem !important;
  }
}
.cursor-pointer {
  cursor: pointer;
}
</style>
